export default __webpack_public_path__ + "images/second-column-badge-blocked.svg";